module.exports = __webpack_public_path__ + "img/portal-files-selection.bf4d2595.jpg";